(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-image"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper(".athleteSwiper", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  breakpoints: {
    600: { slidesPerView: 1.2 },
    900: { slidesPerView: 2.2 },
    1300: { slidesPerView: 3.2 }
  }
});

  } catch(e) { console.error(e); }
})();
})();
